/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cancel_Anytime_FeatureInputs */

const en_cancel_anytime_feature = /** @type {(inputs: Cancel_Anytime_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel any time`)
};

const id_cancel_anytime_feature = /** @type {(inputs: Cancel_Anytime_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Batalkan kapan saja`)
};

const ms_cancel_anytime_feature = /** @type {(inputs: Cancel_Anytime_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Batalkan pada bila-bila masa`)
};

const ca_cancel_anytime_feature = /** @type {(inputs: Cancel_Anytime_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel·la en qualsevol moment`)
};

const cs_cancel_anytime_feature = /** @type {(inputs: Cancel_Anytime_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Můžete kdykoli zrušit`)
};

const da_cancel_anytime_feature = /** @type {(inputs: Cancel_Anytime_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuller når som helst`)
};

const de_cancel_anytime_feature = /** @type {(inputs: Cancel_Anytime_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du kannst jederzeit kündigen`)
};

const et_cancel_anytime_feature = /** @type {(inputs: Cancel_Anytime_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tühistage igal ajal`)
};

const es_cancel_anytime_feature = /** @type {(inputs: Cancel_Anytime_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancela cuando quieras`)
};

const fr_cancel_anytime_feature = /** @type {(inputs: Cancel_Anytime_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annulez à tout moment`)
};

const hr_cancel_anytime_feature = /** @type {(inputs: Cancel_Anytime_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otkažite u svakom trenutku`)
};

const it_cancel_anytime_feature = /** @type {(inputs: Cancel_Anytime_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancella in qualsiasi momento`)
};

const lv_cancel_anytime_feature = /** @type {(inputs: Cancel_Anytime_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atceliet jebkurā laikā`)
};

const lt_cancel_anytime_feature = /** @type {(inputs: Cancel_Anytime_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atšaukti bet kuriuo metu`)
};

const hu_cancel_anytime_feature = /** @type {(inputs: Cancel_Anytime_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bármikor lemondható`)
};

const nl_cancel_anytime_feature = /** @type {(inputs: Cancel_Anytime_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altijd opzegbaar`)
};

const nb_cancel_anytime_feature = /** @type {(inputs: Cancel_Anytime_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si opp når som helst`)
};

const pl_cancel_anytime_feature = /** @type {(inputs: Cancel_Anytime_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anuluj w dowolnym momencie`)
};

const pt_cancel_anytime_feature = /** @type {(inputs: Cancel_Anytime_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar a qualquer momento`)
};

const ro_cancel_anytime_feature = /** @type {(inputs: Cancel_Anytime_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anulează oricând`)
};

const sk_cancel_anytime_feature = /** @type {(inputs: Cancel_Anytime_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Môžete kedykoľvek zrušiť`)
};

const sl_cancel_anytime_feature = /** @type {(inputs: Cancel_Anytime_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prekličite kadarkoli`)
};

const fi_cancel_anytime_feature = /** @type {(inputs: Cancel_Anytime_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peruuta milloin tahansa`)
};

const sv_cancel_anytime_feature = /** @type {(inputs: Cancel_Anytime_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avbryt när som helst`)
};

const vi_cancel_anytime_feature = /** @type {(inputs: Cancel_Anytime_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hủy bất kỳ lúc nào`)
};

const tr_cancel_anytime_feature = /** @type {(inputs: Cancel_Anytime_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İstediğiniz zaman iptal edin`)
};

const el_cancel_anytime_feature = /** @type {(inputs: Cancel_Anytime_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Μπορείτε να ακυρώσετε οποιαδήποτε στιγμή`)
};

const bg_cancel_anytime_feature = /** @type {(inputs: Cancel_Anytime_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отмяна по всяко време`)
};

const ru_cancel_anytime_feature = /** @type {(inputs: Cancel_Anytime_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отмена в любое время`)
};

const sr_cancel_anytime_feature = /** @type {(inputs: Cancel_Anytime_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Откажите у сваком тренутку`)
};

const uk_cancel_anytime_feature = /** @type {(inputs: Cancel_Anytime_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скасування у будь-який час`)
};

const ka_cancel_anytime_feature = /** @type {(inputs: Cancel_Anytime_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`გააუქმეთ ნებისმიერ დროს`)
};

const hi_cancel_anytime_feature = /** @type {(inputs: Cancel_Anytime_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कभी भी कैंसिल करें`)
};

const th_cancel_anytime_feature = /** @type {(inputs: Cancel_Anytime_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยกเลิกได้ทุกเมื่อ`)
};

const ko_cancel_anytime_feature = /** @type {(inputs: Cancel_Anytime_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`언제든지 취소 가능`)
};

const zh_cancel_anytime_feature = /** @type {(inputs: Cancel_Anytime_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`随时取消`)
};

const zh_tw_cancel_anytime_feature = /** @type {(inputs: Cancel_Anytime_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`隨時取消`)
};

const ja_cancel_anytime_feature = /** @type {(inputs: Cancel_Anytime_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いつでもキャンセル可能`)
};

/**
* | output |
* | --- |
* | "Cancel any time" |
*
* @param {Cancel_Anytime_FeatureInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const cancel_anytime_feature = /** @type {((inputs?: Cancel_Anytime_FeatureInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cancel_Anytime_FeatureInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cancel_anytime_feature(inputs)
	if (locale === "ms") return ms_cancel_anytime_feature(inputs)
	if (locale === "ca") return ca_cancel_anytime_feature(inputs)
	if (locale === "cs") return cs_cancel_anytime_feature(inputs)
	if (locale === "da") return da_cancel_anytime_feature(inputs)
	if (locale === "de") return de_cancel_anytime_feature(inputs)
	if (locale === "et") return et_cancel_anytime_feature(inputs)
	if (locale === "es") return es_cancel_anytime_feature(inputs)
	if (locale === "fr") return fr_cancel_anytime_feature(inputs)
	if (locale === "hr") return hr_cancel_anytime_feature(inputs)
	if (locale === "it") return it_cancel_anytime_feature(inputs)
	if (locale === "lv") return lv_cancel_anytime_feature(inputs)
	if (locale === "lt") return lt_cancel_anytime_feature(inputs)
	if (locale === "hu") return hu_cancel_anytime_feature(inputs)
	if (locale === "nl") return nl_cancel_anytime_feature(inputs)
	if (locale === "nb") return nb_cancel_anytime_feature(inputs)
	if (locale === "pl") return pl_cancel_anytime_feature(inputs)
	if (locale === "pt") return pt_cancel_anytime_feature(inputs)
	if (locale === "ro") return ro_cancel_anytime_feature(inputs)
	if (locale === "sk") return sk_cancel_anytime_feature(inputs)
	if (locale === "sl") return sl_cancel_anytime_feature(inputs)
	if (locale === "fi") return fi_cancel_anytime_feature(inputs)
	if (locale === "sv") return sv_cancel_anytime_feature(inputs)
	if (locale === "vi") return vi_cancel_anytime_feature(inputs)
	if (locale === "tr") return tr_cancel_anytime_feature(inputs)
	if (locale === "el") return el_cancel_anytime_feature(inputs)
	if (locale === "bg") return bg_cancel_anytime_feature(inputs)
	if (locale === "ru") return ru_cancel_anytime_feature(inputs)
	if (locale === "sr") return sr_cancel_anytime_feature(inputs)
	if (locale === "uk") return uk_cancel_anytime_feature(inputs)
	if (locale === "ka") return ka_cancel_anytime_feature(inputs)
	if (locale === "hi") return hi_cancel_anytime_feature(inputs)
	if (locale === "th") return th_cancel_anytime_feature(inputs)
	if (locale === "ko") return ko_cancel_anytime_feature(inputs)
	if (locale === "zh") return zh_cancel_anytime_feature(inputs)
	if (locale === "zh-tw") return zh_tw_cancel_anytime_feature(inputs)
	if (locale === "ja") return ja_cancel_anytime_feature(inputs)
	return en_cancel_anytime_feature(inputs)
});